/*
 * @Author: manuelzhao manuelzhao@tencent.com
 * @Date: 2023-01-03 16:41:39
 * @LastEditors: manuelzhao manuelzhao@tencent.com
 * @LastEditTime: 2023-03-10 13:05:22
 * @FilePath: /wemeet-web-activity/src/hooks/useCaptcha.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { loadScript } from '@tencent/web-base';
import { useEffect } from 'react';
import { message } from '@tencent/tea-component';

// 腾讯防水墙APPID
const TencentCaptchaAppId = {
  dev: '2099486352',
  release: '2099486352'
};
const useCaptcha = () => {
  useEffect(() => {
    loadScript('https://ssl.captcha.qq.com/TCaptcha.js');
  }, []);
  const genCaptcha = () => new Promise((resolve, reject) => {
    const captcha = new window.TencentCaptcha(TencentCaptchaAppId.release, res => {
      if (res.ret === 0) {
        resolve(res);
      } else {
        reject(res);
        res.ret !== 2 && message.error({
          content: '验证失败，请重试'
        });
      }
    });
    captcha.show();
  });
  return genCaptcha;
};
export default useCaptcha;